import { Component, Input } from '@angular/core';

@Component({
  selector: 'lm-menu-security-info',
  standalone: false,
  templateUrl: 'lm-menu-security-info.component.html',
  styleUrls: [ 'lm-menu-security-info.component.scss' ],
  })

export class LMMenuSecurityInfoComponent  {

  @Input() lmWebAppComponent: LMWebAppComponent | undefined;
  @Input() lmWebAppComponentItem: LMWebAppComponentItem | undefined;

  constructor() {
  }
}

